import { usePageTitle } from '@/hooks/usePageTitle'

type Props = {
  title: string
  /** Board story that will replace this placeholder with the real screen. */
  storyId: number
}

/**
 * Stub page for a routed screen whose story hasn't been built yet. Gives the
 * shell real navigation targets; each page story replaces its instance.
 */
function Placeholder({ title, storyId }: Props) {
  usePageTitle(title)

  return (
    <div className="willfade">
      <div className="pagehead">
        <div>
          <h1>{title}</h1>
          <p className="pagehead__sub">
            This screen is planned but not built yet — it arrives with story #
            {storyId}.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Placeholder
